








import Vue from 'vue';
import Component from 'vue-class-component';
import HomeIdeasPlaceStart from './HomeIdeasPlaceStart.vue';
import SectionLayout from '../../SectionLayout.vue';
import { getTestPlaces, TestPlace } from '@/models/test-place.model';

@Component({
  components: {
    HomeIdeasPlaceStart,
    SectionLayout
  }
})
export default class HomeIdeasPlace extends Vue {
  places!: TestPlace[];

  showKnowMore: boolean = false;

  navBarTheme!: 'light' | 'dark' | 'default';

  created() {
    this.places = getTestPlaces;
    this.navBarTheme = 'default';
  }
}
